"use client";
import { useEffect } from "react";

import { ORS_DEPRECATION_FC_KEY } from "@ctv/core/feature-control/constants";
import {
  useFeatureControl,
  useLocalizedRouterServer,
} from "@ctv/shared-core/src";
import { Footer, Page } from "@ctv/shared/components/Layout";

import RegistrationContent from "./RegistrationContent";

export default function RegistrationPageContent() {
  const { enabled } = useFeatureControl(ORS_DEPRECATION_FC_KEY);
  const router = useLocalizedRouterServer();

  useEffect(() => {
    if (enabled) {
      router.push("/");
    }
  }, [enabled]);

  if (enabled) {
    return null;
  }

  return (
    <Page light={false}>
      <RegistrationContent />
      <Footer />
    </Page>
  );
}
